import { AlertTitle as MuiAlertTitle } from '@mui/material';
export const AlertTitle = MuiAlertTitle;
